import React from 'react';

const Vendor = () => {
    return (
        <div>
            <h1>Vendor Registration</h1>
            <p>Welcome to the vendor registration page. Please fill out the form to register as a vendor.</p>
            {/* Add your registration form here */}
        </div>
    );
};

export default Vendor;